import React, { memo, useMemo } from 'react';
import { DynamicField } from '@gravity-ui/dynamic-forms';
import noop from 'lodash/noop';
import { Form as FinalForm, FormSpy } from 'react-final-form';
import { dynamicConfig } from '../../dynamic-forms-custom/config';
export const PagePropsForm = memo(({ data: content, spec, onChange }) => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const initialValues = useMemo(() => ({ content }), []);
    return (React.createElement(FinalForm, { initialValues: initialValues, onSubmit: noop }, () => (React.createElement("div", null,
        React.createElement(FormSpy, { onChange: ({ values }) => onChange(Object.assign({}, values.content)), subscription: { values: true } }),
        React.createElement(DynamicField, { name: "content", spec: spec, config: dynamicConfig })))));
});
PagePropsForm.displayName = 'PagePropsForm';
